import React from "react";
import ReactApexChart from "react-apexcharts";

export default function BaseChart({ name, data, categories }) {
  const series = [
    {
      name: name,
      data: data,
    },
  ];

  const options = {
    theme: {
      mode: "dark",
    },
    chart: {
      height: 350,
      type: "bar",
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return new Intl.NumberFormat("en-UK", {
          maximumFractionDigits: 1,
          notation: "compact",
          currency: "KES",
        }).format(val);
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
      },
    },

    xaxis: {
      categories: categories,
      position: "bottom",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return new Intl.NumberFormat("en-UK", {
            currency: "KES",
          }).format(val);
        },
      },
    },
    title: {
      text: name,
      align: "center",
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        gradientToColors: ["rgba(27,27,251,1)"],
        shadeIntensity: 1,
        type: "vertical",
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
  };

  return (
    <>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </>
  );
}
